export default __webpack_public_path__ + "static/lab-88530df66fe01b5c7611cfecc39ac225.jpg";